import {Component} from "inferno";
import CTooltip from "inferno-bootstrap/src/Tooltip";
import {T} from "inferno-i18next";

export class Tooltip extends Component<any, any> {

	node: any;

	state: { open: boolean } = {
		open: false,
	};

	componentDidMount() {
		document.removeEventListener("click", this.node.handleDocumentClick, true);
		document.removeEventListener("touchstart", this.node.handleDocumentClick, true);
	}

	toggle = (e: any) => {
		if (!this.props.disabled) {
			this.setState({open: !this.state.open});
		}
	}

	render() {
		return (
			<CTooltip ref={(node: any) => this.node = node} target={this.props.target} placement={this.props.placement || "auto"} isOpen={this.state.open} toggle={this.toggle}
					delay={{"show": 600, "hide": 100}}>
				<T i18nKey={this.props.content}>X</T>
			</CTooltip>
		);
	}
}
